import { useState } from "react";
import ReportType from "./ReportType";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import { SearchDatePickerWrapper } from "../../../../components/common/datatable/filter/SearchDatePickerWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useLazyExportAggregateUserEfficencyReportDataQuery, useLazyExportCountyReportDataQuery, useSearchAggUserEfficReportApiQuery, useSearchCountyReportApiQuery } from "../report";
import { useGetAllTenantsQuery } from "../../../customer/tenantApi";
import { useLazyGetAllUserByTenantQuery } from "../../../user/users/usersApi";
import { getCurrentMonthStartDate } from "../../../../helpers/utils/Utils";


const AggregateUserEfficiencyReport = () => {

    const tenantData = useGetAllTenantsQuery("");
    const [userTenantApi, userTenant] = useLazyGetAllUserByTenantQuery();
    const [type, setType] = useState('AGGREGATE_USER_EFFICIENCY_REPORT');
    const [triggerExportReportDataQuery] = useLazyExportAggregateUserEfficencyReportDataQuery();
    const formattedStartDate = getCurrentMonthStartDate();

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Aggregate User Efficiency Report", url: "" }]
    )


    const columns: DataTableColumn[] = [
        {
            label: "Tenant",
            accessor: "tenant",
            overrideSortColumn: "tenant",
            visibility: { hasShowSetting: false, canColumnShow: false },
            filterOptions: [{
                dependentColumns: ["User"],
                filterComponent: SearchSelectWithList(tenantData?.data, "name", "name", "Select Tenant...", false, "tenant", null),
                overrideFilterAccessor: "tenant",
            }],
        },
        {
            label: "User",
            accessor: "user",
            overrideSortColumn: "assigned_to",
            visibility: { hasShowSetting: false },
            filterOptions: [{
                filterComponent: SearchSelectWithList(userTenant?.data, "username", "id", "Select User(s)...", true, "assigneeList", null),
                overrideFilterAccessor: "assigneeList", overrideFilterLabel: "User(s)",
                onDependencyUpdated: (value: string) => {
                    userTenantApi(value);
                },
            }],
        },
        {
            label: "Assigned", accessor: "assigned", canSort: false
        },
        {
            label: "Completed",
            accessor: "completed",
            canSort: false,
            filterOptions: [{
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"}
                />,
                overrideFilterAccessor: "createdDateFrom",
                overrideFilterLabel: "Created Date - From",
            }, {
                filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"}
                />,
                overrideFilterAccessor: "createdDateTo",
                overrideFilterLabel: "Created Date - To",
            }]

        },
        {
            label: "Delivered",
            accessor: "delivered",
            canSort: false,
        },
        {
            label: "Average Completed Time", accessor: "medianCompletedTime", canSort: false
        },
        {
            label: "Average Delivered Time", accessor: "medianDeliveredTime", canSort: false
        },
    ];

    const customFilter = {
        createdDateFrom: formattedStartDate,
    }

    return (
        <>
            <div className="user-container px-4 py-2">
                <div className="flex justify-between">
                    <Breadcrumb crumbs={crumbs} />
                </div>
                <ReportType type={type} setType={setType} />
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchAggUserEfficReportApiQuery,
                        exportAction: triggerExportReportDataQuery
                    }}
                    defaultFilter={
                        {
                            ...customFilter,
                            "sortOrder": "ASCENDING",
                            "pageNumber": 0,
                            "pageSize": "15",
                            "sort": "assigned_to"
                        }
                    }
                    userSettingGroup={"Aggregate User Efficiency Report"}
                    basePermission={"AGGUSRREPO"}
                />
            </div>
            <div />
        </>
    )


}

export default AggregateUserEfficiencyReport;